export const OPT_IN_GROUPS = [
    'BG59',
    'C0001',
    'C0002'
];
export const OPT_OUT_GROUPS = [
    'BG59',
    'C0001',
    'C0002',
    'SSPD_BG',
    'C0004',
    'C0003'
];
export const GLOBAL_GROUPS_OPT_IN = ',BG59,C0001,C0002,SSPD_BG,C0004,C0003,';
export const GLOBAL_GROUPS_OPT_OUT = ',BG59,C0001,C0002,';
export const DPM_LEGACY_COOKIE_NAME = 'OptanonConsent';
export const DPM_ALERT_BOX_CLOSED_COOKIE_NAME = 'OptanonAlertBoxClosed';
export const DPM_COOKIE_NAME = 'dpm_preferences';
export const DPM_COOKIE_EXPIRATION_DAYS = 365; // 1 year
